import { useState, useEffect, useContext } from 'react'
import ContextStates from '../../context/ContextStates'
import axios from 'axios'
import { Url } from '../Url'
import { FaPlus } from "react-icons/fa";
import DetalleCompra from './detalleCompra'
import SearchAutoComplete from '../searchAutoComplete';


const FormCompra = () => {

    const [descripcion, setDescripcion] = useState('')
    const [descripcionExt, setDescripcionExt] = useState('')
    const [precio, setPrecio] = useState('')
    const [precioCosto, setPrecioCosto] = useState('')
    const [stock, setStock] = useState('')
    const [stockMin, setStockMin] = useState('')
    const [producto, setProducto] = useState({})
    const [rubros, setRubros] = useState([])
    const [guardar, setGuardar] = useState(false)
    const [proveedores, setProveedores] = useState([])
    const { modify, setModify, setFormView, setViewOpen, productos, setProductos, valMarca, valRubro, detalleCompra, setDetalleCompra,
        searchTerm, setSearchTerm, proveedor, setProveedor, rubro, setRubro, codigo, setCodigo, tipoCompra, setTipoCompra } = useContext(ContextStates)

    useEffect(() => {
        const getProductos = async () => {
            const formData = new FormData()
            formData.append('id', 1);
            try {
                const results = await axios({
                    url: Url + 'api/listadoproductos.php',
                    method: 'POST',
                    data: formData,
                })
                setProductos(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getProductos()
    }, [modify])

    useEffect(() => {
        if (typeof producto.id !== 'undefined') {
            let rData = [...detalleCompra];
            let encontrado = 0;
            rData.forEach(element => {
                if (element.id === producto.id && producto.id !== 0) {
                    element.stock = parseFloat(element.stock) + parseFloat(producto.stock);
                    encontrado = 1;
                }
            });
            if (encontrado === 0)
                rData.push(producto)
            setDetalleCompra(rData)
            setProducto({})
        }
    }, [producto])

    useEffect(() => {
        if (rubros.length > 0) {
            let aux = rubros[0].id;
            setRubro(aux)
        }
    }, [rubros])

    useEffect(() => {
        const consultaRubros = async () => {
            const url = Url + 'api/listRubros.php?rubrocero=1';
            const resultado = await axios.get(url);
            setRubros(resultado.data.results);
        }
        consultaRubros()
    }, [])

    /*useEffect(() => {
        const getProveedores = async () => {
            const url = Url + 'api/listProveedores.php';
            const resultado = await axios.get(url);
            setProveedores(resultado.data.results);
            setProveedor(resultado.data.results[0].id)
        }
        getProveedores()
    }, [])*/

    const altaCompra = async () => {
        console.log("hasta aqui si")
        if (guardar) {
            console.log("tambien")
            if (tipoCompra === 1) {
                setProducto({
                    id: 0,
                    codigo: '',
                    descripcion: searchTerm,
                    preciocosto: precioCosto,
                    stock: 1
                })
                setCodigo('')
                setSearchTerm('')
                setPrecio('')
                setPrecioCosto('')
                setStock('')

            }
            else {
                const formData = new FormData()
                formData.append('codigo', codigo);
                formData.append('descripcion', searchTerm);
                formData.append('idrubro', rubro);
                //formData.append('precio', precio);
                formData.append('preciocosto', precioCosto);
                formData.append('stock', stock);
                formData.append('tipoCompra', tipoCompra);
                try {
                    const results = await axios({
                        url: Url + 'api/altaCompras.php',
                        method: 'POST',
                        data: formData,
                    })
                    //console.log(results)
                    let aux = modify + 1;
                    setModify(aux)
                    setProducto(results.data.results)
                    setCodigo('')
                    setSearchTerm('')
                    setPrecio('')
                    setPrecioCosto('')
                    setStock('')
                } catch (e) {
                    console.log(e)
                }
            }
        }
    }

    useEffect(() => {
        const checkProducto = async () => {
            if (codigo !== '') {
                const formData = new FormData()
                formData.append('codigo', codigo);

                try {
                    const results = await axios({
                        url: Url + 'api/checkProducto.php',
                        method: 'POST',
                        data: formData,
                    })
                    console.log(results)
                    if (typeof results.data.results !== 'undefined') {
                        setSearchTerm(results.data.results.descripcion);
                        setRubro(results.data.results.idrubro)
                        setPrecio(results.data.results.precio);
                        //setPrecioCosto(results.data.results.preciocosto);
                        setStock('0');
                        setStockMin(results.data.results.alerta);
                    }
                    else {
                        setSearchTerm('');
                        setPrecio('');
                        setPrecioCosto('');
                        setStock('');
                        setStockMin('');
                    }

                } catch (e) {
                    console.log(e)
                }
            }
        }
        checkProducto()
    }, [codigo])

    useEffect(() => {
        const checkForm = () => {
            let error = 0;
            if (searchTerm === '')
                error = 1;
            if (precioCosto === '' || precioCosto === 0 || precioCosto === '0')
                error = 1;

            if (error === 0)
                setGuardar(true)
            else
                setGuardar(false)
        }
        checkForm()
    }, [searchTerm, codigo, precio, precioCosto, stock, rubro])


    const handleAdd = (form) => {
        setFormView(form)
        setViewOpen(true)
    }


    return (

        <div className="transition-all w-full pt-5 sm:p-3 mt-5 mb-5">
            <h2 className='text-center text-gray-700 text-sm md:text-2xl uppercase'>Nuevo Gasto</h2>
            <div className='w-full p-5 uppercase'>
                <div className='w-full'>
                    <label>
                        <input
                            type="radio"
                            name="tipoCompra"
                            value={1}
                            checked={tipoCompra === 1}
                            onChange={() => setTipoCompra(1)}
                            className='mr-5'
                        />
                        Gasto o Pago
                    </label>
                </div>
                <div className='w-full mt-5'>
                    <label>
                        <input
                            type="radio"
                            name="tipoCompra"
                            value={2}
                            checked={tipoCompra === 2}
                            onChange={() => setTipoCompra(2)}
                            className='mr-5'
                        />
                        Compra de Producto
                    </label>
                </div>
            </div>
            {/*tipoCompra === 1 && (
                <div className='w-full mx-auto m-3 p-5'>
                    <div className='p-3 bg-white border border-gray-200 rounded-lg'>
                        <label htmlFor="sProveedor" className="w-full block mt-5 text-gray-600 uppercase">Proveedor</label>
                        <select
                            className='py-2 px-3 w-full rounded bg-slate-100 mr-2'
                            id='sProveedor'
                            value={proveedor}
                            onChange={(e) => setProveedor(e.target.value)}
                        >
                            {proveedores && (
                                proveedores.map(item => (
                                    <option key={item.id} value={item.id}>{item.nombre}</option>))
                            )}
                        </select>
                    </div>
                </div>
            )*/}
            <h2 className='text-center text-gray-700 text-xl'></h2>
            <div className='w-full flex'>
                <div className='w-1/3'>
                    <div className='w-full'>
                        <div className="w-full mt-5 py-2 px-3 rounded-2xl">
                            <div className='w-full'>
                                <div className='w-full mx-auto m-3 p-2'>
                                    <div className='p-3 bg-white border border-gray-200 rounded-lg shadow-xl'>
                                        <h4 className='text-center text-gray-700 uppercase'>{tipoCompra === 1 ? 'Gasto o Pago' : 'Producto y marca'}</h4>
                                        {tipoCompra === 2 && (
                                            <div className="sm:items-start">
                                                <label htmlFor="codigo" className="block mt-5 text-gray-600 uppercase">Código</label>
                                                <input
                                                    className="py-2 px-3 w-full border border-gray-300 rounded"
                                                    id="codigo"
                                                    placeholder="Código de producto"
                                                    type="text"
                                                    value={codigo}
                                                    onChange={(e) => setCodigo(e.target.value)}
                                                    autoFocus
                                                />
                                            </div>
                                        )}
                                        <div className="sm:items-start">
                                            <div className="w-full sm:items-start mt-3">
                                                <SearchAutoComplete
                                                    items={productos}
                                                />
                                            </div>
                                        </div>
                                        {tipoCompra === 2 && (
                                            <>
                                                <label htmlFor="sRubro" className="w-full block mt-5 text-gray-600 uppercase">Rubro</label>
                                                <select
                                                    className='py-2 px-3 w-full rounded bg-slate-100 mr-2'
                                                    id='sRubro'
                                                    value={rubro}
                                                    onChange={(e) => setRubro(e.target.value)}
                                                >
                                                    {rubros && (
                                                        rubros.map((item, index) => (
                                                            <option key={index} value={item.id}>{item.descripcion}</option>))
                                                    )}
                                                </select>
                                            </>
                                        )}
                                    </div>
                                </div>
                                <div className='w-full mx-auto m-3 p-2'>
                                    <div className='p-3 bg-white border border-gray-200 rounded-lg shadow-xl'>
                                        <div className="sm:items-start">
                                            <label htmlFor="precioCosto" className="block mt-5 text-gray-600 uppercase">Monto a pagar</label>
                                            <input
                                                className="py-2 px-3 w-full border border-gray-300 rounded"
                                                id="precioCosto"
                                                placeholder="Monto a pagar"
                                                type="text"
                                                value={precioCosto}
                                                onChange={(e) => setPrecioCosto(e.target.value)}
                                            />
                                        </div>
                                        {tipoCompra === 2 && (
                                            <div className='flex'>
                                                <div className="sm:items-start px-1">
                                                    <label htmlFor="stock" className="block mt-5 text-gray-600 uppercase">Cantidad</label>
                                                    <input
                                                        className="py-2 px-3 w-full border border-gray-300 rounded"
                                                        id="stock"
                                                        placeholder="Stock"
                                                        type="text"
                                                        value={stock}
                                                        onChange={(e) => setStock(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="mt-auto w-full p-3">
                                <button
                                    type="button"
                                    className={`w-full shadow-md p-3 text-gray-100 hover:text-gray-300 transition-all uppercase font-bold rounded-lg mt-5 ${guardar ? 'bg-orange-600' : 'bg-orange-100'}`}
                                    onClick={() => altaCompra()}
                                    disabled={!guardar}
                                >
                                    Agregar Producto
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='w-2/3'>
                    <DetalleCompra />
                </div>
            </div>
        </div>
    )
}

export default FormCompra